import { formatDate } from '@/utils/func';
import { TFunction } from 'i18next';
import { AppModalProps } from '@/components/common';

export interface CreateHelpdeskIssueParams {
  profile: UserProfileEntity;
  university: UniversityEntity;
  projectId: number;
  categoryId: number;
  subject: string;
  description: string;
  dormitory: UserDormitoryEntity;
  uploads: { token: string; name: string; type: string; }[];
  t: TFunction;
}

export interface HelpdeskMessageModalProps extends AppModalProps {
  issue: RedmineIssueEntity
  onComplete: () => any;
}

export const statusColor = {
  'تایید شده': '#60CB67',
  'در صف انتظار': '#B28823',
  'در حال بررسی': '#2F93F0',
  'پایان‌یافته': '#BCB9B9',
  'لغو شده': '#E6E6E6',
  'پاسخ داده شده': '#55CC6C',
};

export const samadUserIds = [
  155,
  157
];

export enum HelpdeskStatus {
  New = 1,
  Updated = 22,
  WaitQueue = 20,
  Answered = 3,
  Pending = 11,
  Finished = 5,
  Rejected = 6,
  Confirmed = 18,
  Archive = 23,
  Canceled = 24
}

export function createHelpdeskIssue({
  profile,
  university,
  projectId,
  categoryId,
  subject,
  description,
  dormitory,
  uploads = [],
  t
}: CreateHelpdeskIssueParams) {

  const unknownText = t('common:labels.unknown');
  const yesText = t('common:labels.yes');
  const noText = t('common:labels.no');

  return ({
    subject,
    description,
    project_id: projectId,
    category_id: categoryId,
    tracker_id: 35,
    status_id: 20,
    custom_fields: [
      { id: 70, value: university?.universityLabel },
      { id: 72, value: profile?.username },
      { id: 85, value: 'WEB' },
      { id: 91, value: `${profile.firstName} ${profile.lastName}` },
      { id: 92, value: profile.mobileNumber },
      { id: 93, value: profile.email },
      {
        id: 94,
        // eslint-disable-next-line no-prototype-builtins
        value: profile.student?.hasOwnProperty('isDormitoryResident') ? profile.student?.isDormitoryResident ? yesText : noText : unknownText,
      },
      { id: 115, value: profile?.firstName ?? unknownText },
      { id: 116, value: profile?.lastName ?? unknownText },
      { id: 117, value: profile?.fatherName ?? unknownText },
      { id: 118, value: profile?.gender ?? unknownText },
      {
        id: 119,
        value: Object.prototype.hasOwnProperty.call(profile, 'enabled') ? profile.enabled ? yesText : noText : unknownText,
      },
      { id: 120, value: profile?.nationalCode ?? unknownText },
      { id: 121, value: (profile?.personnel != null) ? profile?.personnel ? yesText : noText : unknownText },
      { id: 122, value: (profile?.faculty != null) ? profile?.faculty ? yesText : noText : unknownText },
      { id: 123, value: profile?.birthDate ? formatDate(profile.birthDate) : unknownText },
      { id: 124, value: profile?.address ?? unknownText },
      { id: 125, value: profile?.postalCode ?? unknownText },
      { id: 126, value: profile?.mobileNumber ?? unknownText },
      { id: 127, value: profile?.shenasnameNumber ?? unknownText },
      { id: 128, value: profile?.birthPlace ?? unknownText },
      { id: 129, value: profile?.issuePlace ?? unknownText },
      // 130 تاریخ صدور
      { id: 131, value: profile?.marriageStatus?.name ?? unknownText, },
      { id: 132, value: profile?.province?.name ?? unknownText },
      { id: 133, value: profile?.city?.name ?? unknownText },
      { id: 134, value: profile?.militaryServiceStatus?.name ?? unknownText },
      { id: 135, value: profile?.religion?.name ?? unknownText },
      // 136 ملیت
      { id: 137, value: profile?.username ?? unknownText },
      { id: 138, value: profile.student?.semester ?? unknownText },
      { id: 139, value: profile?.student?.entranceType ?? unknownText },
      { id: 140, value: profile?.student?.studyLevel?.name ?? unknownText },
      { id: 141, value: profile?.student?.studyMajor?.name ?? unknownText },
      { id: 142, value: profile?.student?.studyMajor?.description ?? unknownText },
      { id: 143, value: profile?.student?.educationalStatus?.name ?? unknownText },
      { id: 144, value: profile?.student?.passedSemesters ?? unknownText },
      { id: 156, value: dormitory?.dormitoryRoom?.code ?? unknownText },
      // { id: 156, value: dormitory?.dormitoryRoom?.dormitory?.name ?? unknownText },
      { id: 157, value: dormitory?.dormitoryRoom?.dormitoryFloor?.name ?? unknownText },
      { id: 158, value: dormitory?.dormitoryBlock?.name ?? unknownText }
    ],
    ...(uploads?.length > 0 ? { uploads } : {})
  });
}

export function getUserAssignId(issue: RedmineIssueEntity) {
  const lastJournal = issue?.journals?.reverse()
    .find((x) => ![155, 157].includes(x.user.id));
  const userId = lastJournal?.user?.id || (lastJournal as any)?.assigned_to?.id;
  return userId;
}

export function isSamadUser(user: IdName | number) {
  if (typeof user === 'object') {
    return samadUserIds.findIndex(x => x === user.id) > -1;
  }
  return samadUserIds.findIndex(x => x === Number(user));
}

export function filterIssueAttachments(issue: RedmineIssueEntity) {

  const result: RedmineIssueAttachmentEntity[] = [];

  const allDetails: RedmineIssueJournalDetailsEntity[] = [];
  for (const journal of (issue?.journals ?? [])) {
    allDetails.push(...journal.details);
  }

  issue.attachments.filter(att => {
    for (const detail of allDetails) {
      if (detail.property !== 'attachment') continue;
      if (String(detail.name) === String(att.id)) {
        return false;
      }
    }
    result.push(att);
  });

  return result;
}
